export default __webpack_public_path__ + "static/media/canvas-rotation-right.1c85e659.svg";